import React from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'
import { setTempAnalystCommentValue, getCommentValue, dateFormatter } from '../../helpers'
import { addAnalystComment } from "../../control"


const AddCommentModal = observer((props) => {

    const saveAndCloseCommentModal = () => {
        if (store.commentAnalystContent.Comment != store.commentAnalystContent.TempComment) addAnalystComment();
        store.showCommentModal = false;
        //this should actually be after we get a response that it was successful

    }
    const closeCommentModal = () => {
        store.showCommentModal = false;
    }
   

    const onChange = e => {
        store.commentAnalystContent.TempComment = e.target.value;

    };
  
    const clearComment = e => {
        store.commentAnalystContent.TempComment = "";

    };

    return (
        <React.Fragment>
            <section>

                <Modal
                    visible={store.showCommentModal}
                    width="765"
                    height="420"
                    effect="fadeInDown"
                    onClickAway={closeCommentModal}
                >
                    <div className="commentModal">
                     
                        <h3> <i className="fa fa-comment"></i> Add Comment</h3>
                        <hr />
                        <div className="row">
                         
                            <div className="col-md-6">
                                <div className="row">

                                    <span className="comment-heading">Provided Value: </span> &nbsp; {store.commentAnalystContent.ProvidedValue} <br />
                                </div>
                                <div className="row">
                                    <span className="comment-heading">Value Edited By: </span> &nbsp; {store.commentAnalystContent.EditedBy}<br />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="row">
                                    <span className="comment-heading">Current Value: </span> &nbsp; {store.commentAnalystContent.CurrentValue} <br />
                                </div>
                                    <div className="row">
                                    <span className="comment-heading">Date Modified: </span> &nbsp; {dateFormatter(store.commentAnalystContent.DateModified)}<br />
                                </div>

                                </div>

                        </div><br />
                        <span className="comment-heading">Comment: </span>
                        <textarea type="text" onChange={onChange} value={getCommentValue()}></textarea>
                        {store.commentAnalystContent.Comment &&
                        <button type="button" className="btn btn-left-align" onClick={clearComment}>Remove Comment</button>
                        }

                        <button type="button" className="btn btn-close" onClick={saveAndCloseCommentModal}>Save & Close</button>
                        <button type="button" className="btn btn-close grey" onClick={closeCommentModal}>Cancel</button>
                    </div>



                </Modal>
            </section>
        </React.Fragment>
    );

});

export default AddCommentModal;